import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { displayDropdown, updateWatchlist, newActiveVideo, setSelectedAsset, setSelectedAssetRow } from '../../redux/actions/SVOD';

class PosterItem extends React.Component {
	constructor(props) {	
		super(props);
		this.state = {
			timeIn: '',
			timeOut: '',
			imageLoaded: false,
		};

		this.backgroundFadeInterval = {};
		this.video = this.props.video; 
		this.label = this.props.label;
		this.idx = this.props.idx;

		this.mouseEnter = this.mouseEnter.bind(this);
		this.mouseLeave = this.mouseLeave.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
		this.updateWatchlist = this.updateWatchlist.bind(this);
		this.triggerReport = this.triggerReport.bind(this);
		this.selectAsset = this.selectAsset.bind(this);
	}

	componentDidMount() {
		this.backgroundFadeInterval = setInterval(() => {
			if (!this.state.imageLoaded) {
				let img = document.getElementById(`${this.label}-${this.video._id.valueOf()}-img`);
				if (img && img.complete) {
					img.style.opacity = 1;
					this.setState({ imageLoaded: true });
				}
			}
		}, 500);
	}

	componentWillUnmount() {
		if (this.backgroundFadeInterval) {
			clearInterval(this.backgroundFadeInterval);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevState.imageLoaded && this.state.imageLoaded) {
			clearInterval(this.backgroundFadeInterval);
		}

		if (prevState.timeOut !== this.state.timeOut) {
			if (this.state.timeOut - this.state.timeIn > 3000) {
				this.props.eventHandler({
					data: { event_type: "time_interacted_with", type: "poster", action: "end_time", asset_id: this.video._id.valueOf(), start_time: this.state.timeIn, end_time: this.state.timeOut }
				});
			}
		}
	}

	handleOpen(e) {

		this.props.eventHandler({
			data:
				{ event_type: "opened_dropdown", type: "asset_details_dropdown", action: "opened_dropdown", asset_id: this.video._id.valueOf(), time: Date.now() }
		});

		let payload = {
			video: this.video,
			label: this.label
		};
		this.props.newActiveVideo("dropdown");
		this.props.displayDropdown(payload);

		let oldSelected = document.getElementsByClassName("selected-vid")[0];

		if (oldSelected !== undefined) {
			oldSelected.classList.remove("selected-vid");
		}
		let newSelected = document.getElementById(`video-${this.label}-${this.idx}`);
		newSelected.classList.add("selected-vid");
	}

	mouseEnter() {
		
		if (this.props.dropdown.video === undefined) {
			let vidsInRow = document.getElementsByClassName(`videoItem-${this.label}`);
			
			for (let i = 0; i < vidsInRow.length; i++) {

				if (i < this.idx) {
					let vid = vidsInRow[i];
					let oldTransform = vid.style.transform;
					vid.style.transform = `${oldTransform} translate3d(-10px, 0, 0)`;
				} else if (i > this.idx) {
					let vid = vidsInRow[i];
					let oldTransform = vid.style.transform;
					vid.style.transform = `${oldTransform} translate3d(10px, 0, 0)`;
				} else {
					let vid = vidsInRow[i];
					let oldTransform = vid.style.transform;
					vid.style.transform = `${oldTransform} scale(1.1)`;
				}
			}
			this.setState({ timeIn: Date.now() });
		}
	}

	mouseLeave() {

		if (this.props.dropdown.video === undefined) {
			let vidsInRow = document.getElementsByClassName(`videoItem-${this.label}`);
			
			for (let i = 0; i < vidsInRow.length; i++) {
				let vid = vidsInRow[i];
				let oldTransform = vid.style.transform.split(")");
				let newTransform = '';

				if (oldTransform[0].includes("translateX")) {
					newTransform += oldTransform[0] + ")";
				}
				vid.style.transform = newTransform;
			}  
			this.setState({ timeOut: Date.now() });
		}
	}

	updateWatchlist() {

		if (this.props.watchlist.includes(this.video._id.valueOf())) {
			this.props.eventHandler({ data: { event_type: "watchlist", action: "removed_from_watchlist", type: "poster", asset_id: this.video._id.valueOf(), time: Date.now() } });

			let newWatchlist = this.props.watchlist.filter((value) => { return value !== this.video._id.valueOf(); });
			this.props.updateWatchlist(newWatchlist);
		} else {
			this.props.eventHandler({ data: { event_type: "watchlist", action: "added_to_watchlist", type: "poster", asset_id: this.video._id.valueOf(), time: Date.now() } });
			let newWatchlist = [...this.props.watchlist, this.video._id.valueOf()];
			this.props.updateWatchlist(newWatchlist);
		}
	}

	triggerReport() {
		this.props.eventHandler({ data: { event_type: "asset_fullscreen_playback", type: "poster", action: "asset_fullscreen_playback", asset_id: this.video._id.valueOf(), time: Date.now() } });
	}

	selectAsset(asset) {
		this.props.setSelectedAsset(asset);
		this.props.setSelectedAssetRow(this.props.label);
	}

	render() {
		let watchlistButton = (this.props.watchlist.includes(this.video._id.valueOf())) ? (
			<button onClick={this.updateWatchlist} className="poster-watchlist" id={`watchlist-${this.video._id.valueOf()}`}><i className="fas fa-check"></i></button>
		) : (
			<button onClick={this.updateWatchlist} className="poster-watchlist" id={`watchlist-${this.video._id.valueOf()}`}><i className="fas fa-plus"></i></button>
		);

		return (
			<span className={`${this.video._id} videoItem-${this.label} poster-index-item`} id={`video-${this.label}-${this.idx}`} onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave} onClick={() => this.selectAsset(this.props.video)}>
				<div className="poster-container">
					<img className="poster-pic" id={`${this.label}-${this.video._id.valueOf()}-img`} src={this.video.images.poster} />
				</div>

				<div className="poster-hover-buttons">
					<Link to="/study/watch" onClick={this.triggerReport}>
						<button className="hover-buttons-play poster-play" ><i className="fas fa-play" /></button>
					</Link> 
					
					{watchlistButton}
					<button className="poster-dropdown" onClick={this.handleOpen}><i className="fas fa-chevron-down" /></button>
				</div>

			</span>
		);
	}
}


const mapStateToProps = (state) => ({
	dropdown: state.SVOD.dropdown,
	watchlist: state.SVOD.watchlist,
});


const mapDispatchToProps = (dispatch) => ({
	displayDropdown: (payload) => dispatch(displayDropdown(payload)),
	updateWatchlist: (newWatchlist) => dispatch(updateWatchlist(newWatchlist)),
	newActiveVideo: (payload) => dispatch(newActiveVideo(payload)),
	setSelectedAsset: (asset) => dispatch(setSelectedAsset(asset)),	
	setSelectedAssetRow: (label) => dispatch(setSelectedAssetRow(label)),	
});

export default connect(mapStateToProps, mapDispatchToProps)(PosterItem);
// export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(PosterItem);



// WEBPACK FOOTER //
// ./src/components/svod/poster-item.jsx